import { formatDateBasedOnTimezone } from "../../utils/date.utils";
import { getValue } from "../../utils/object.utils";

export const transformResultListTableData = (resultList: Array<any>): any[] => {
  const transformDatForTable = resultList.map((result: any): any => {
    return {
      id: getValue(result, "id"),
      label: getValue(result, "label"),
      code: getValue(result, "code"),
      publishDate: formatDateBasedOnTimezone({
        date: getValue(result, "publish_date"),
      }),
      schoolBranchName: getValue(result, "school_branch.name"),
      className: getValue(result, "class.name"),
    };
  });

  return transformDatForTable;
};
